import { updateSuccessSection } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useUpdateSection = () => {
    const queryClient = useQueryClient();
    return useMutation(updateSuccessSection, {
        onSuccess: () => {
            toast.success("Section updated sucesfully");
            queryClient.invalidateQueries('monthlySuccess');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}